module.exports = __webpack_public_path__ + "static/facial-recognition-7efe6629f0b9c8c483fa5dd6c2e8ee62.svg";